export default __webpack_public_path__ + "static/media/71t.82e76075.jpg";